import { snackbarService } from 'uno-material-ui';

export const sendMessage = (message: string, type = 'success') => snackbarService.showSnackbar(message, type);
